import type React from 'react';
import cx from 'classnames';
import { Icons } from '@/shared/Icons/Icons';

import styles from './styles.module.css';

interface AnimatedCheckboxProps {
  isChecked: boolean;
  onChange?: () => void;
  label?: string;
  disabled?: boolean;
}

const Checkbox: React.FC<AnimatedCheckboxProps> = ({
  isChecked,
  onChange = () => {},
  label = '',
  disabled = false,
}) => {
  const handleCheckboxChange = (evt: React.MouseEvent | React.ChangeEvent) => {
    evt.preventDefault();
    evt.stopPropagation();
    onChange();
  };

  return (
    <div
      onClick={handleCheckboxChange}
      className={cx(
        styles.customControl,
        styles.customCheckbox,
        disabled ? styles.disabled : '',
      )}
    >
      <input
        type="checkbox"
        checked={isChecked}
        onChange={handleCheckboxChange}
        className={cx(styles.customControlInput)}
        id={`block-venue-${label}`}
        name={`block-venue-${label}`}
      />
      <label
        className={cx(styles.customControlLabel)}
        htmlFor={`block-venue-${label}`}
      >
        <span className={cx(styles.checkmark, isChecked ? styles.active : '')}>
          {isChecked ? <Icons.CheckMark /> : null}
        </span>
        <span className={styles.label}> {label} </span>
      </label>
    </div>
  );
};

export default Checkbox;
